module.exports = __webpack_public_path__ + "img/barcode-active-icon.45e9bf9b.svg";